export default __webpack_public_path__ + "static/media/signinimage.83e95ce5.png";